import { SvgIcon, SvgIconProps } from '@/theme/index';
export function WeaponIcon(props: SvgIconProps) {
  const { color } = props;
  return (
    <SvgIcon {...props}>
      <path
        d="M16.5 0.75C16.5 0.334375 16.1656 0 15.75 0C15.3344 0 15 0.334375 15 0.75V1H1C0.446875 1 0 1.44687 0 2V5.5C0 6.05312 0.446875 6.5 1 6.5H1.3125C1.9625 6.5 2.44062 7.1125 2.28125 7.74375L1.03125 12.7563C0.95625 13.0563 1.025 13.3719 1.2125 13.6156C1.4 13.8594 1.69062 14 2 14H5C5.45937 14 5.85938 13.6875 5.96875 13.2437L6.78125 10H10.0469C10.7875 10 11.4469 9.53437 11.6938 8.8375L12.5281 6.5H13.5C13.7656 6.5 14.0188 6.39375 14.2063 6.20625L14.9156 5.5H17C17.5531 5.5 18 5.05312 18 4.5V2C18 1.44687 17.5531 1 17 1H16.5V0.75ZM10.0437 8.5H7.15625L7.65625 6.5H10.9375L10.2812 8.33438C10.2469 8.43438 10.15 8.5 10.0469 8.5H10.0437ZM2.5 3H14.5C14.775 3 15 3.225 15 3.5C15 3.775 14.775 4 14.5 4H2.5C2.225 4 2 3.775 2 3.5C2 3.225 2.225 3 2.5 3Z"
        fill={color || '#8750FF'}
      />
    </SvgIcon>
  );
}
